module.exports = __webpack_public_path__ + "static/media/game development.57330eb1.jpg";